module.exports = __webpack_public_path__ + "images/stickers/taco-active@2x.83272719c60c68228016.png";